<script>
export default {
  name: 'TCalendarCell',
  inject: ['calendar'],
  props: {
    date: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      value: this.date
    }
  },
  methods: {
    $_onClick() {
      this.value.isSelected = !this.value.isSelected
      this.calendar.$emit('select-date', this.value.isSelected)
    }
  },
  render(h) {
    const slot = this.calendar.$scopedSlots.date
    return h('div', {
      class: {
        'day-cell': true,
        'today': this.date.isToday,
        'not-cur-month': !this.date.valid,
        'selected-day': this.value.isSelected
      },
      on: {
        click: this.$_onClick
      }
    }, [
      slot ? slot(this.value) : h('p', {
        class: 'day-number'
      }, this.date.date)
    ])
  }
}
</script>



// WEBPACK FOOTER //
// src/module/calendar/calendar-cell.vue